'use strict'

const embed = {
		init: function () {
				this.buttons = document.querySelectorAll(".start-youtube");

				this.events();
		},

		events: function () {
				var self = this;

				this.onClick();
		},

		onClick: function () {
				var self = this;
				for (let i = 0; i < this.buttons.length; i++) {
						this.buttons[i].addEventListener("click", function (e) {
								var frameId = this.getAttribute('data-embed-id')
								var wrapper = this.getAttribute('data-embed-wrapper')
								var caption = this.getAttribute('data-embed-caption')

								this.classList.add("opacity-0")
								this.classList.add("invisible")

								if (wrapper != null) {
										var embedWrapper = this.closest(wrapper)
										embedWrapper.classList.remove("overlay-gradient")
										embedWrapper.classList.remove("overlay-color")
										if (caption != null) {
												var embedCaption = embedWrapper.querySelectorAll(caption)
												embedCaption[0].classList.add("opacity-0")
												embedCaption[0].classList.add("invisible")
										}
								}

								var iframe = document.getElementById(frameId)

								if (iframe && iframe.tagName.toUpperCase() != 'IFRAME') {
										iframe = iframe.getElementsByTagName('iframe')[0]
								}

								if (iframe) {
										iframe.contentWindow.postMessage(JSON.stringify({
												"event": "command",
												"func": "playVideo",
												"id": frameId
										}), "*")
								}
						});
				}
		},
}

export default embed.init()
